import { useEffect, useState } from "react";

const TICK_MS = 30_000;

/**
 * Whole minutes elapsed since `startedAt`. Ticks on a cheap 30s interval —
 * this is calm, ambient information (contrast with useTimers' 1s tick, which
 * drives live countdowns for running timers; do NOT piggyback that one here).
 * Clamped to 0 to guard against clock skew (e.g. a `startedAt` momentarily in
 * the future relative to the client clock).
 */
export function useElapsedMin(startedAt: string): number {
  const [now, setNow] = useState<number>(() => Date.now());

  useEffect(() => {
    // Recompute immediately when startedAt changes, then keep ticking.
    setNow(Date.now());
    const t = setInterval(() => setNow(Date.now()), TICK_MS);
    return () => clearInterval(t);
  }, [startedAt]);

  const elapsedMs = now - new Date(startedAt).getTime();
  return Math.max(0, Math.floor(elapsedMs / 60_000));
}
